var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blockchain"},[_c('Header'),_c('div',{staticClass:"content"},[_c('Blockchain')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }